import { employees, page as pageQuery } from '@data/queries';
import { styled } from '@mui/material/styles';
import sanity from '@utils/sanity';
import { ReactElement } from 'react';
import { EmployeeProps } from 'src/@types/employee';
import { PageProps } from 'src/@types/page';
import Routes from 'src/routes';
import { ContactInfo } from 'src/sections/contact';
import Newsletter from 'src/sections/newsletter/Newsletter';
import Team from 'src/sections/team/Team';
import { Page } from '../src/components';
import { HEADER_DESKTOP_HEIGHT, HEADER_MOBILE_HEIGHT } from '../src/config';
import Layout from '../src/layouts';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  paddingTop: HEADER_MOBILE_HEIGHT,
  [theme.breakpoints.up('md')]: {
    paddingTop: HEADER_DESKTOP_HEIGHT,
  },
}));

// ----------------------------------------------------------------------

type Props = {
  data: {
    employees: EmployeeProps[];
  }
  page: PageProps;
};

export default function ContactUsPage({ data, page }: Props) {
  return (
    <Page seo={page.seo}>
      <RootStyle>
        <ContactInfo />

        <Team members={data.employees} />

        <Newsletter />
      </RootStyle>
    </Page>
  );
}

// ----------------------------------------------------------------------

ContactUsPage.getLayout = function getLayout(page: ReactElement) {
  return <Layout>{page}</Layout>;
};

// ----------------------------------------------------------------------

export const getStaticProps = async () => {
  const query = `
    {
      "employees": ${employees}
    }
  `

  const data = await sanity.fetch(query);
  const page = await sanity.fetch(pageQuery, { slug: Routes.contact });
  return {
    props: { data, page }, // will be passed to the page component as props
  };
};
